import { provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { BrowserTracing } from '@sentry/tracing';

Sentry.init({
  environment: environment.platform,
  dsn: 'https://74bf7b39f2594dd6806db3589a6d8575@o1140239.ingest.sentry.io/6620051',
  ignoreErrors: ['Non-Error exception captured'],
  integrations: [
    Sentry.browserTracingIntegration({
      instrumentNavigation: true,
    }),
    // Registers the Replay integration,
    // which automatically captures Session Replays
    Sentry.replayIntegration(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100% of transactions for performance monitoring. We recommend adjusting this value in production
  tracesSampleRate: environment.sentryTraceSampleRate,
  tracePropagationTargets: ['localhost', /^https:\/\/.*rouseanalytics\.com/],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: environment.platform === 'Production' ? 1.0 : 0,
});

platformBrowserDynamic().bootstrapModule(AppModule, {
  applicationProviders: [provideZoneChangeDetection()],
});

// Disable logging in production.
if (environment.platform === 'Production' && window) {
  window.console.log = function () {};
  window.console.warn = function () {};
  window.console.error = function () {};
  window.console.time = function () {};
  window.console.timeEnd = function () {};
}
